var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRafraenSkilriki(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.568 11.508a10.453 10.453 0 00-2.66-6.425M.583 14.417v3.5A10.5 10.5 0 007 27.593M16.333 2.99A10.5 10.5 0 00.6 11.5M8.167 5.718a7 7 0 019.916 6.333",
    stroke: "#fff",
    strokeWidth: 1.167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 24.893a7 7 0 01-7.583-6.977v-5.833a6.973 6.973 0 011.782-4.666",
    stroke: "#fff",
    strokeWidth: 1.167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.583 13.893v-1.81a3.5 3.5 0 10-7 0v3.5M7.583 17.917a3.5 3.5 0 003.5 3.5M11.083 12.083v3.5M11.083 17.917v1.166M11.083 28.417c.771 0 1.54-.084 2.292-.251M13.417 21.417a7 7 0 1013.999 0 7 7 0 00-14 0z",
    stroke: "#fff",
    strokeWidth: 1.167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.536 19.382L20.147 23.9a.875.875 0 01-1.318.095l-1.75-1.75",
    stroke: "#fff",
    strokeWidth: 1.167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgRafraenSkilriki;